/* eslint-disable max-lines */
import React, {useMemo, useState} from 'react';
import {Card} from 'semantic-ui-react';
import {InventoryLinesColumnFilter} from '../internalCommons/TableFilters';
import {Actions} from '../../../common/actions';
import {connect} from 'react-redux';
import {cloneDeep} from 'lodash';
import '../styles.scss';
import {tableHeaderStockWithProps} from './columns/stockColumns';
import {tableHeaderTransitWithProps} from './columns/transitColumns';
import {mapListToDropdownList} from '../../utils/mainUtils';
import FormFilters from './formFilters';
import CommercialTable from '../../../common/components/commercialTable/commercialTable';
import {handleExcelReport} from '../../../common/components/commercialTable/exportUtils/handleExport';
import {customValuesVehiclesInventory} from '../../utils/dataByLineUtils';

const generateListsVehiclesTypes = (vehicleTypes) => {
  const typesS1SU = [];
  const typesRest = [];

  vehicleTypes.map((vehicleType) => {
    if (['N', 'U', 'G'].includes(vehicleType.code)) {
      typesS1SU.push({
        'key': vehicleType.code,
        'value': vehicleType.code,
        'text': vehicleType.description,
      });
    } else if (vehicleType.code === 'O') {
      typesS1SU.push({
        'key': vehicleType.code,
        'value': vehicleType.code,
        'text': vehicleType.description,
      });
      typesRest.push({
        'key': vehicleType.code,
        'value': vehicleType.code,
        'text': vehicleType.description,
      });
    } else {
      typesRest.push({
        'key': vehicleType.code,
        'value': vehicleType.code,
        'text': vehicleType.description,
      });
    }
  });
  return {
    typesS1SU,
    typesRest,
  };
};

const VehiclesByLineTable = ({
  modelsByLine,
  fetchUpdateModelsLine,
  filterLines,
  group,
  listDealers,
  updateTable,
  vehiclesTypesList,
  filters,
  generatefilteredRows,
  setInventoryByLine,
  updateInventoryByLineTable,
  isUserTde,
  dealerId,
}) => {
  const listDealersAll = mapListToDropdownList(listDealers, {
    'keys': ['identification'],
    'values': ['identification'],
    'texts': ['name'],
  });
  const clone = cloneDeep(modelsByLine);
  const listVehiclesTypes = generateListsVehiclesTypes(vehiclesTypesList);

  const columnsTable =
    group === 'stock' ?
      tableHeaderStockWithProps({
        'lists': {listDealersAll, listVehiclesTypes},
        fetchUpdateModelsLine,
        'filters': filterLines,
        isUserTde,
        dealerId,
      }) :
      tableHeaderTransitWithProps({
        'data': clone,
        'lists': {listDealersAll, listVehiclesTypes},
        fetchUpdateModelsLine,
        'filters': filterLines,
        isUserTde,
        dealerId,
      });
  const data = useMemo(() => clone, [updateTable, filters]);
  const columns = useMemo(() => columnsTable, [updateTable]);

  const [filteredData, setfilteredData] = useState([]);
  const handleSubmit = (event) => {
    const excelRows = filteredData.map((row) => {
      return row.original;
    });
    handleExcelReport(
      excelRows,
      columnsTable,
      customValuesVehiclesInventory,
      'REPORTE-INVENTARIO');

    event.preventDefault();
  };

  const transitAndStock = [50, 95, 45, 120, 215];
  const stockTDE = [80, 50, 95, 45, 120, 215];

  const fixedColumns = group === 'stock' && isUserTde ? (
    stockTDE
  ) : (
    transitAndStock
  );
  return (
    <>
      <Card
        raised
        fluid
        className='card-wrapper-auto'
      >
        <FormFilters
          generatefilteredRows={generatefilteredRows}
          group={group}
          filters={filters}
          handleSubmit={handleSubmit}
        />
        <CommercialTable
          columns={columns}
          data={data}
          tableType='fixed'
          defaultColumnFilter={InventoryLinesColumnFilter}
          setFilteredData={setfilteredData}
          fixedColumns={fixedColumns}
          tableStyles={'inventory-by-line-table'}
          isSmallCell={true}
        />
      </Card>
    </>
  );
};

const mapStateToProps = (state) => ({
  'listDealers': state.dealer.list,
  'updateTable': state.vehiclesInventory.updateTable,
  'vehiclesTypesList': state.vehiclesTypes.list,
  'isUserTde': state.session.isUserFromTDE,
  'dealerId': state.session.dealerId,
});

const {
  fetchUpdateModelsLine,
  setInventoryByLine,
  updateInventoryByLineTable,
} = Actions;

export default connect(mapStateToProps, {
  fetchUpdateModelsLine,
  setInventoryByLine,
  updateInventoryByLineTable,
})(VehiclesByLineTable);
